import { formatDateForDisplay, getTimeUntilDay } from '@/shared/lib/calendarDate';
import { addS } from '@/shared/lib/addS';

export const SHORT_DATE: Intl.DateTimeFormatOptions = {
  month: 'short',
  day: 'numeric',
};

export const formatStartsIn = (startsAt: string): string => {
  const timeUntilStart = getTimeUntilDay(startsAt);
  const date = formatDateForDisplay(startsAt, undefined, SHORT_DATE);

  if (!timeUntilStart) {
    return `Starts ${date}`;
  }

  const { calendarDayOffset } = timeUntilStart;
  if (calendarDayOffset === 0) return 'Starts today';

  return `Starts ${date} · in ${calendarDayOffset} ${addS(calendarDayOffset, 'day')}`;
};
